import LocationsModal from './locationsModal'

export default LocationsModal